module.exports = {"nationList":["汉族","回族","壮族","满族","阿昌族","白族","保安族","布朗族","布依族","朝鲜族","达斡尔族","傣族","德昂族","东乡族","侗族","独龙族","俄罗斯族","鄂伦春族","鄂温克族","高山族","仡佬族","哈尼族","哈萨克族","赫哲族","基诺族","京族","景颇族","柯尔克孜族","拉祜族","黎族","傈僳族","珞巴族","毛南族","门巴族","蒙古族","苗族","仫佬族","纳西族","怒族","普米族","羌族","撒拉族","畲族","水族","塔吉克族","塔塔科族","土家族","土族","佤族","维吾尔族","乌孜别克族","锡伯族","瑶族","彝族","裕固族","藏族"],"relationList":["爸爸","妈妈","爷爷","奶奶","外公","外婆","其他"]}


//////////////////
// WEBPACK FOOTER
// ./static/nation.json
// module id = BGbr
// module chunks = 1